import { render } from "./ViewSettings.vue?vue&type=template&id=6d9e582a&scoped=true&ts=true"
import script from "./ViewSettings.vue?vue&type=script&lang=ts"
export * from "./ViewSettings.vue?vue&type=script&lang=ts"

import "./ViewSettings.vue?vue&type=style&index=0&id=6d9e582a&lang=scss&scoped=true"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d9e582a"]])

export default __exports__